import { useSnackbar } from "notistack";
import CloseIcon from "@material-ui/icons/Close";
import React, { Fragment, useEffect, useState } from "react";

const useNotification = () => {
  const [conf, setConf] = useState({});
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const action = (key) => (
    <Fragment>
      <CloseIcon
        onClick={() => {
          closeSnackbar(key);
        }}
      />
    </Fragment>
  );
  useEffect(() => {
    if (conf?.msg) {
      let variant = "info";
      if (conf.variant) {
        variant = conf.variant;
      }
      enqueueSnackbar(conf.msg, {
        variant: variant,
        autoHideDuration: null,
        action,
        anchorOrigin: { horizontal: "right", vertical: "top" },
      });
    }
  }, [conf]);
  return [conf, setConf];
};

export default useNotification;
